export interface PartnerBookingPolicy {
  // TODO: Clean up partner booking policy since no use case as all FE use cases involve
  // space booking policy. We should centralize effort in getting policy from space
  // /api/v2/spaces/:id/booking_policy. This time slot increment is used for date/time
  // filter on meeting room gallery page and FE should fetch from /api/v2/partner_offerings/:id/filter_configs
  timeSlotIncrement: number;
  terms: string;
}
export interface PartnerBookingHour {
  openAt: string;
  closedAt: string;
}
export interface Testimonial {
  testimonial: string;
  name: string;
  avatar?: string;
  companyTitle?: string;
  companyLogo?: string;
  reviewLink?: string;
  reviewLinkText?: string;
  stars?: number;
  showQuoteIcon?: boolean;
}

export function toPartnerBookingPolicy(data: any): PartnerBookingPolicy {
  return {
    timeSlotIncrement: data.time_slot_select_minute_increment,
    terms: data.terms,
  };
}

export function toPartnerBookingHour(data: any): PartnerBookingHour {
  return {
    openAt: data.open_at,
    closedAt: data.closed_at,
  };
}

export function toPartnerTestimonial(data: any): Testimonial {
  return {
    name: data.testifier_name,
    testimonial: data.content,
    avatar: data.testifier_avatar,
    companyLogo: data.testifier_company_logo,
    companyTitle: data.testifier_company_title,
    reviewLink: data.review_link,
    reviewLinkText: data.review_link_text,
    stars: data.stars,
    showQuoteIcon: data.show_quote_icon,
  };
}
